import { useNavigate, useSearchParams } from 'react-router';
import { ListItemButton } from '@mui/material';
import { gridRowSelectionIdsSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import { useAppDispatch } from '@reduxStore';
import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { setDispatchSnapshot } from '@/Infrastructure/applicationSlice';
import { useMemo } from 'react';
import useCurrentTerminal from '@/Hooks/useCurrentTerminal';

/**
 * View All Legs by JobId Action and csnNo
 */
export default function ViewAllConsignmentsAction() {
	const gridApiRef = useGridApiContext();
	const appDispatch = useAppDispatch();
	const [searchParameters, setSearchParams] = useSearchParams();
	const navigate = useNavigate();
	const { number: terminalNumber } = useCurrentTerminal();
	const selectedRowIds = useGridSelector(gridApiRef, gridRowSelectionIdsSelector);
	const isOnBoard = location.pathname.includes('/Board');

	const leg = useMemo(() => {
		const legId = selectedRowIds.keys().next().value;
		return legId ? gridApiRef.current.getRow<DispatchLeg>(legId) : undefined;
	}, [gridApiRef, selectedRowIds]);

	// This action requires exactly 1 row to be selected
	if (selectedRowIds.size !== 1 || searchParameters.get('job') || !leg) {
		return <></>;
	}

	const handleBtnClick = () => {
		/** Snapshot the current Board we are on for routing back */
		appDispatch(setDispatchSnapshot(`${location.pathname}${location.search}`));

		const params = new URLSearchParams({
			job: leg.jobId.toString()
		});

		if (isOnBoard) {
			setSearchParams(params);
		} else {
			void navigate(`/${terminalNumber}/Board?${params.toString()}`);
		}
	};

	return <ListItemButton onClick={handleBtnClick}>View All Containers for this Order</ListItemButton>;
}
